import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-no-access',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './no-access.component.html',
    styleUrl: './no-access.component.scss'
})
export class NoAccessComponent {
    constructor(private authService: AuthService) { }

    logout() {
        this.authService.logOut();
    }
}
